/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scrape_Router_SentenceInputs */

const en_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We send every page to the cheapest scraper that can actually scrape it.`)
};

const zh_hans1_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们把每个页面交给真正能抓取它的最便宜的抓取器。`)
};

const pt_br2_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviamos cada página para o scraper mais barato que realmente consegue extraí-la.`)
};

const es_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviamos cada página al scraper más barato que realmente puede extraerla.`)
};

const fr_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous envoyons chaque page au scraper le moins cher qui sait vraiment l’extraire.`)
};

const de_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir schicken jede Seite an den günstigsten Scraper, der sie wirklich scrapen kann.`)
};

const ru_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы отправляем каждую страницу самому дешёвому скраперу, который действительно может её получить.`)
};

const it_scrape_router_sentence = /** @type {(inputs: Scrape_Router_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandiamo ogni pagina allo scraper più economico che riesce davvero a estrarla.`)
};

/**
* | output |
* | --- |
* | "We send every page to the cheapest scraper that can actually scrape it." |
*
* @param {Scrape_Router_SentenceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const scrape_router_sentence = /** @type {((inputs?: Scrape_Router_SentenceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scrape_Router_SentenceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_scrape_router_sentence(inputs)
	if (locale === "pt-BR") return pt_br2_scrape_router_sentence(inputs)
	if (locale === "es") return es_scrape_router_sentence(inputs)
	if (locale === "fr") return fr_scrape_router_sentence(inputs)
	if (locale === "de") return de_scrape_router_sentence(inputs)
	if (locale === "ru") return ru_scrape_router_sentence(inputs)
	if (locale === "it") return it_scrape_router_sentence(inputs)
	return en_scrape_router_sentence(inputs)
});